/** Un ítem de biblioteca de imágenes (logos de juego hoy; siluetas de merch en CH-14). */
export interface LibraryItem {
  /** Nombre de fichero o etiqueta; se enseña sin extensión ni guiones. */
  name: string;
  url: string;
  /** Agrupación opcional (categoría). Sin ella, una sola rejilla. */
  group?: string;
}

/** «lunch-bag_white.svg» → «lunch bag white». */
export function prettyName(name: string): string {
  return name.replace(/\.[a-z0-9]+$/i, '').replace(/[-_]+/g, ' ').trim();
}

/** Prefijo público de la biblioteca de siluetas (CH-14). */
export const OUTLINE_PREFIX = '/uploads/merch-outlines/';

/**
 * ¿La imagen del ítem es una silueta de la biblioteca y no la foto real?
 * La silueta es el respaldo, no la meta: el planner debe verlo antes del evento.
 */
export function isOutline(url: string | null | undefined): boolean {
  if (!url) return false;
  return url.includes(OUTLINE_PREFIX);
}
